import { CSSProperties } from 'react'

export const s = {
  costItemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    gap: 8,
    marginBottom: 8,
  } as CSSProperties,
  costAndAmount: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: 8,
  } as CSSProperties,
  costItem: { fontWeight: 500, fontSize: '16px', color: '#262626' } as CSSProperties,
}
